import React from 'react';
import { styled } from '@mui/material/styles';
import { Box, Checkbox, MenuItem, Radio, Typography } from '@mui/material';
const PREFIX = 'ModifierSelectOption';

const classes = {
    label: `${PREFIX}label`,
    description: `${PREFIX}description`,
    image: `${PREFIX}image`,
    icon: `${PREFIX}icon`
};

const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
    [`& .${classes.label}`]: {
        whiteSpace: 'pre-wrap'
    },

    [`& .${classes.description}`]: {
        opacity: 0.7
    },

    [`& .${classes.image}`]: {
        height: '40px',
        width: '40px',
        backgroundPosition: 'center',
        borderRadius: theme.shape.borderRadius,
        overflow: 'hidden',
        backgroundSize: 'cover',
        marginLeft: 'auto'
    },

    [`& .${classes.icon}`]: {
        padding: 0,
        color: theme.palette.hint,
        '&.Mui-checked': {
            color: theme.palette.hint
        }
    }
}));

export interface IModifierSelectOption {
    label: string;
    description?: string;
    value: string;
    disabled?: boolean;
    image?: string;
}

interface ModifierSelectOptionProps {
    item: IModifierSelectOption;
    multi: boolean;
    selected: boolean;
    disabled: boolean;
    onClick: (value: string) => void;
}

export const ModifierSelectOption: React.FC<React.PropsWithChildren<ModifierSelectOptionProps>> = ({
    item,
    multi,
    selected,
    disabled,
    onClick
}) => {
    const handleClick = React.useCallback(() => {
        onClick(item.value);
    }, [onClick, item.value]);
    return (
        <StyledMenuItem value={item.value} key={item.value} disabled={disabled} onClick={handleClick}>
            <Box flex={1}>
                <Typography className={classes.label}>{item.label}</Typography>
                {item.description && (
                    <Typography className={classes.description} variant="caption">
                        {item.description}
                    </Typography>
                )}
            </Box>
            {!!item.image && (
                <div className={classes.image} style={{ backgroundImage: `url(${item.image})` }} />
            )}
            {multi ? (
                <Checkbox className={classes.icon} disableRipple disableTouchRipple checked={selected} />
            ) : (
                <Radio className={classes.icon} disableRipple disableTouchRipple checked={selected} />
            )}
        </StyledMenuItem>
    );
};
